define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../../store", "../services", "../services/EventManager"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, store_1, services_1, EventManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FDoc = void 0;
    class FDoc extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "FacilityId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FacilityIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocDescError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsUpload", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsUploadError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Facility", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FDoc.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Facility = parent;
            this.FacilityId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Facility = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.FacilityId = (0, EntityUtil_1.toInt)(entity.FacilityId);
            a.AssetId = (0, EntityUtil_1.toInt)(entity.AssetId);
            a.DocType = (0, EntityUtil_1.toInt)(entity.DocType);
            a.DocName = b.DocName;
            a.DocDesc = b.DocDesc;
            a.IsUpload = (0, EntityUtil_1.toInt)(entity.IsUpload);
            a.AuditCreateDate = b.AuditCreateDate;
            a.AuditCreateUser = b.AuditCreateUser;
            a.AuditEditDate = b.AuditEditDate;
            a.AuditEditUser = b.AuditEditUser;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FDoc.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "FacilityId", "Facility Id");
                this.validateReqNumber(validationState, "DocType", "Document Type");
                this.validateReqString(validationState, "DocName", "Document Name");
                this.validateReqNumber(validationState, "IsUpload", "Is Uploaded?");
                this.validateReqDate(validationState, "AuditCreateDate", "AUDIT_CREATE_DATE");
                this.validateReqString(validationState, "AuditCreateUser", "AUDIT_CREATE_USER");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                FacilityId: this.FacilityId,
                AssetId: this.AssetId,
                DocType: this.DocType,
                DocName: this.DocName,
                DocDesc: this.DocDesc,
                IsUpload: this.IsUpload,
                AuditCreateDate: this.AuditCreateDate,
                AuditCreateUser: this.AuditCreateUser,
                AuditEditDate: this.AuditEditDate,
                AuditEditUser: this.AuditEditUser,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        static openDocument(document) {
            services_1.SrmsServiceManager.Instance.Facility.getFacilityDocument(document.Id);
        }
        static uploadDocument(f, documentType, fileName, base64File) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Uploading Document");
                if (f.hasChanges()) {
                    store_1.StoreManager.Instance.modalStore.createInfoModal("You have unsaved changes. Please save your work before uploading a document", null);
                }
                else {
                    services_1.SrmsServiceManager.Instance.Facility.uploadFacilityDocument(f.Id, documentType, fileName, base64File).then(d => {
                        let x = new FDoc(d, f);
                        f.FDoc.push(x);
                        resolve(x);
                    });
                }
            });
        }
    }
    exports.FDoc = FDoc;
    Object.defineProperty(FDoc, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FDoc"
    });
    Object.defineProperty(FDoc, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Document"
    });
    Object.defineProperty(FDoc, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "FacilityId", "AssetId", "DocType", "DocName", "DocDesc", "IsUpload", "AuditCreateDate", "AuditCreateUser", "AuditEditDate", "AuditEditUser"]
    });
    Object.defineProperty(FDoc, "FacilityIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FDoc, "AssetIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FDoc, "DocTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FDoc, "DocTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FDoc, "DocNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FDoc, "DocNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FDoc, "DocDescLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FDoc, "DocDescTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter a description for the document"
    });
    Object.defineProperty(FDoc, "DocDescReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FDoc, "IsUploadReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FDoc, "AuditCreateDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FDoc, "AuditCreateUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FDoc, "AuditCreateUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FDoc, "AuditEditDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FDoc, "AuditEditUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FDoc, "AuditEditUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "FacilityId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "FacilityIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "AssetId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "AssetIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "DocType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "DocTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "DocName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "DocNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "DocDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "DocDescError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "IsUpload", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "IsUploadError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "AuditCreateDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "AuditCreateDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "AuditCreateUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "AuditCreateUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "AuditEditDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "AuditEditDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "AuditEditUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "AuditEditUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FDoc.prototype, "Facility", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FDoc.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FDoc.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FDoc.prototype, "merge", null);
});
